import { cloudCode } from ".";
import { useAuth } from "@/store/auth";
import { dataSyncEmitter } from "../events/emitter";

export function getDevices(): Promise<AllDevices> {
  return cloudCode.run("getCameritoDevices");
}

export async function verifyDeviceIsPaired() {
  const xmppLogin = useAuth.getState().device.xmppCredentials?.xmppLogin;
  if (!xmppLogin) return;

  const allDevices: AllDevices | null = await getDevices();
  if (!allDevices) return;

  const isPaired = allDevices.devices.some((device) => device.xmppLogin === xmppLogin);
  if (!isPaired) {
    log.auth("Device is no longer paired to the account");
    dataSyncEmitter.emit("device-not-paired");
  }
}

export function removeDeviceFromAccount({ xmppLogin }: { xmppLogin: string }) {
  return cloudCode.run("removeDeviceFromAccount", { xmppLogin });
}
export function setDeviceName({
  xmppLogin,
  deviceName
}: {
  xmppLogin: string;
  deviceName: string;
}): Promise<ParseDevice> {
  return cloudCode.run("setDeviceName", { xmppLogin, deviceName });
}
